<template>
  <el-row class="height-100 back-color  pb-30">
    <el-row class=" pl-20 form-header top-form">
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item label="项目名称">
          <el-input v-model="queryForm.projectName" />
        </el-form-item>
        <el-form-item label="合同名称">
          <el-select
            v-model="queryForm.contractName"
            filterable
          >
            <el-option
              v-for="(item, index) in relationNames"
              :key="index"
              :label="item.contractName"
              :value="item.contractName"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="结算状态">
          <el-select v-model="queryForm.submitStatus">
            <el-option
              v-for="item in statusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="opt">
          <el-button
            type="primary"
            @click="search"
          >
            确定
          </el-button>
          <el-button
            type="info"
            @click="reset"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row class="body">
      <el-row class="top pl-20 pt-20">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="medium"
          @click="handleAdd"
        >
          新增
        </el-button>
        <el-button
          :disabled="deleDisabled"
          type="danger"
          icon="el-icon-delete"
          size="medium"
          @click="deleteItems"
        >
          删除
        </el-button>
      </el-row>
      <el-row class="mt-20">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          @selection-change="selecChange"
        >
          <el-table-column
            type="selection"
            align="center"
            :selectable="checkSelectable"
          />
          <el-table-column
            label="合同名称"
            prop="contractName"
            header-align="center"
            width="260px"
          >
            <template slot-scope="scope">
              <el-row v-if="scope.row.settlementSubmitContracts">
                <span
                  v-for="(item, index) in scope.row.settlementSubmitContracts"
                  :key="index"
                >
                  {{ item.projectName }}
                  &nbsp;
                  {{ item.contractName }}
                  &nbsp;
                  {{ item.contractCode }}

                  <i
                    v-if="
                      index < scope.row.settlementSubmitContracts.length - 1
                    "
                    class="pl-3"
                  >
                  </i>
                  <br />
                </span>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            label="结算类型"
            align="center"
            width="120px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type === 'LWJS'">
                分包结算
              </span>
              <span v-if="scope.row.type === 'ZLJS'">
                租赁结算
              </span>
              <span v-if="scope.row.type === 'CLJS'">
                材料结算
              </span>
              <span v-if="scope.row.type === 'QTJS'">
                其他结算
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="结算审批状态"
            align="center"
            width="110px"
          >
            <template slot-scope="scope">
              <!-- 0-未提交,1-待审核,2-已取消,3-审批驳回,4-审批中,5-已撤销,6-已通过 -->
              <span
                v-if="scope.row.submitStatus === 0"
                style="color: #FE900D"
              >
                未提交
              </span>
              <span
                v-else-if="scope.row.submitStatus === 3"
                style="color: #FE900D"
              >
                待修改
              </span>
              <span
                v-else-if="scope.row.submitStatus === 7"
                style="color: #FE900D"
              >
                审批待修改
              </span>
              <span v-else>
                {{ scope.row.submitStatus | replyStatus }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="发票累计金额(元)"
            prop="submitAmount"
            align="center"
            width="130px"
          />
          <el-table-column
            label="创建时间"
            prop="createTime"
            align="center"
            width="160px"
          />
          <el-table-column
            label="更新时间"
            prop="updateTime"
            align="center"
            width="160px"
          />
          <el-table-column
            width="160px"
            label="操作"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-col class="align-center">
                <el-button
                  type="text"
                  @click.native="checkItem(scope.row, 1)"
                >
                  查看
                </el-button>
                <el-button
                  v-if="
                    scope.row.submitStatus === 0 ||
                      scope.row.submitStatus === 3 ||
                      scope.row.submitStatus === 7
                  "
                  type="text"
                  @click.native="checkItem(scope.row, 2)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="
                    scope.row.submitStatus === 0 ||
                      scope.row.submitStatus === 3 ||
                      scope.row.submitStatus === 7
                  "
                  type="text"
                  @click.native="redelivery(scope.row)"
                >
                  提交
                </el-button>
              </el-col>
            </template>
          </el-table-column>
        </el-table>
        <el-col class="mt-40 align-center">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="queryForm.pageSize"
            :current-page="queryForm.pageNum"
            :total="total"
            @current-change="currentChange"
          />
        </el-col>
      </el-row>
    </el-row>
    <el-dialog
      v-if="dialogVisible"
      :title="title"
      :visible.sync="dialogVisible"
      width="65%"
      append-to-body
      @close="dialogClose"
    >
      <DialogView
        :disabled="dialogDisabled"
        :form-data="dialogForm"
        @close="dialogClose"
      />
    </el-dialog>
    <!--<el-dialog
      v-if="submitVisible"
      title="提交信息"
      :visible.sync="submitVisible"
      width="60%"
    >
      <submitDialog
        ref="submitDialog"
        :item="formData"
      />
    </el-dialog>-->
  </el-row>
</template>

<script>
import relaAPI from '@/http/merchant/relation'
import api from '@/http/merchant/submit'
import submitDialog from './modules/submitDialog'
import DialogView from './modules/dialog'
// import fileMixins from '@/components/Mixins/FileMixins' fileMixins, 

export default {
  components: { DialogView },
  mixins: [submitDialog],
  data() {
    return {
      img: '',
      formData: null,
      relationNames: [],
      tableData: [],
      deleDisabled: true,
      dialogDisabled: false,
      dialogVisible: false,
      title: '新增结算提交',
      severLoading: {},
      submitForm: {
        syncTicketResultList: [],
        syncCheckAnnexIdsList: []
      },
      submitItem: {},
      queryForm: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      relationOption: [],
      statusOption: [
        {
          label: '未提交',
          value: 0
        },
        {
          label: '待审批',
          value: 1
        },
        {
          label: '已取消',
          value: 2
        },
        {
          label: '待修改',
          value: 3
        },
        {
          label: '审批中',
          value: 4
        },
        {
          label: '已撤销',
          value: 5
        },
        {
          label: '已通过',
          value: 6
        },
        {
          label: '审批待修改',
          value: 7
        }
      ],
      nameOption: [],
      dialogForm: null,
      loading: false,  
      selectArr: []
    }
  },
  created() {
    this.initRelationLsit()
    this.initData()
  },
  methods: {
    initData() {
      this.loading = true
      api.getListByPage(this.queryForm).then(
        res => {
          this.loading = false
          if (res.code === this.sucCode) {
            // console.log('结算列表', res)
            this.total = res.total
            this.tableData = res.rows
            if (this.tableData.length < 1 && this.queryForm.pageNum > 1) {
              this.queryForm.pageNum -= 1
              this.initData()
            }
          } else {
            this.$message.error(res.msg)
          }
        },
        () => {
          this.loading = false
        }
      )
    },
    initRelationLsit() {
      relaAPI.getOwnList().then(res => {
        if (res.code === this.sucCode) {
          this.relationOption = res.data
          this.filterName()
        }
      })
    },
    checkSelectable(row) {
      let flag = false
      if (row.submitStatus === 0) {
        flag = true
      }
      return flag
    },
    handleAdd() {
      this.title = '新增结算提交'
      this.dialogVisible = true
    },
    selecChange(rows) {
      this.selectArr = rows
      this.selectArr.length > 0
        ? (this.deleDisabled = false)
        : (this.deleDisabled = true)
    },
    checkItem(item, type) {
      this.dialogForm = this.deepCopy(item)
      if (type === 1) {
        this.title = '查看结算提交'
        this.dialogDisabled = true
      } else {
        this.title = '编辑结算提交'
        this.dialogDisabled = false
      }
      this.dialogVisible = true
    },
    search() {
      this.queryForm.pageNum = 1
      this.initData()
    },
    reset() {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10
      }
      this.initData()
    },
    deleteItems() {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      })
        .then(() => {
          this.$loading()
          const ids = this.selectArr.map(item => {
            return item.id
          })
          api.deleteByIds(ids.join()).then(
            res => {
              this.$loading().close()
              if (res.code === this.sucCode) {
                this.$message.success('删除成功!')
                this.initData()
              } else {
                this.$alert(res.msg, '提示', {
                  confirmButtonText: '确定',
                  type: 'error'
                })
              }
            },
            () => {
              this.$loading().close()
              this.$message.error('删除失败，请稍后重试!')
            }
          )
        })
        .catch(() => {
          this.$message.info('已取消！')
        })
    },
    redelivery(item) {
      this.fileIsChecked(item).then(res => {
        if (res) {
          this.$confirm(
            '该结算提交数据提交后不可进行编辑、删除, 确定是否提交?',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
          .then(() => {
            this.severLoading = this.$loading({
              text: '正在上传发票等文件，请耐心等待...',
              lock: true,
              spinner: 'el-icon-loading'
            })
            this.initSubmitMixins()
            this.initFileMixins()
            // 在submitDialog中监听item的变化，如果值有变化则进行提交
            this.item = this.deepCopy(item)
          })
          .catch(() => {
            this.$message.info('已取消！')
          })
        } else {
           this.$confirm(
            '该结算提交数据提交后不可进行编辑、删除, 确定是否提交?',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            this.severLoading = this.$loading({
              text: '正在上传发票等文件，请耐心等待...',
              lock: true,
              spinner: 'el-icon-loading'
            })
            this.submitFn(item)
          })
          // this.$message.warning('已提交成功，无需再提交！')
        }
      })
    },
    // 判断是否需要上传OCR等
    fileIsChecked(item) {
      return new Promise(resolve => {
        // status 0 待核验 1核验成功 2核验失败
        let tag = false
        // 发票列表
        const invoList = item.settlementInvoiceList || []
        if (invoList.length === 0) {
          this.$message.error('请先上传发票图片！')
          return
        }
        // 结算确认单列表
        const confirmeList = item.settlementAnnexes || []
        for(let i = 0; i < invoList.length; i++) {
          if (invoList[i].status !== 1) {
            tag = true
            resolve(tag)
          }
        }
        for(let i = 0; i < confirmeList.length; i++) {
          if (confirmeList[i].status !== 1) {
            tag = true
            resolve(tag)
          }
        }
        resolve(tag)
      })
    },
    // 提交数据
    submitFn(item) {
      api.submitData(item).then(
        res => {
          this.severLoading.close()
          if (res.code === this.sucCode) {
            this.$message.success('提交成功!')
            this.initData()
          } else {
            this.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              type: 'error'
            })
          }
        },
        () => {
          this.severLoading.close()
          this.$message.error('提交失败，请稍后重试!')
        }
      )
    },
    dialogClose(tag) {
      this.dialogVisible = false
      this.dialogForm = null
      this.dialogDisabled = false
      if (tag) {
        this.queryForm.pageNum = 1
        this.initData()
      }
    },
    currentChange(val) {
      this.queryForm.pageNum = val
      this.initData()
    },
    filterName() {
      const names = []
      this.relationOption.forEach(item => {
        if (!names.includes(item.contractName)) {
          names.push(item.contractName)
          this.relationNames.push(item)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.status-0 {
  color: #f6b63f;
}
.status-1 {
  color: $primary;
}
::v-deep {
  .el-loading-text {
    text-align: center!important;
  }
}
 .el-loading-text {
    text-align: center!important;
  }
</style>
